import { hasValue } from 'utils/hasValue';

import { EXPORTED_PAYINS_MODAL_TEST_ID } from '../../constants';

type DownloadPayinReportsCardProps = {
  createdAfter: string;
  createdBefore: string;
  virtualAccountNumber: string;
  status?: string | null;
};

export const DownloadPayinReportsCard = ({
  createdAfter,
  createdBefore,
  virtualAccountNumber,
  status
}: DownloadPayinReportsCardProps) => {
  return (
    <div
      className="flex flex-col space-y-2 bg-surface-muted p-3"
      data-testid={EXPORTED_PAYINS_MODAL_TEST_ID}
    >
      <div>
        <div>Date range:</div>
        <div className="font-semibold">
          From {createdAfter} To {createdBefore}
        </div>
      </div>
      <div>
        <div>Account:</div>
        <div className="font-semibold">{virtualAccountNumber}</div>
      </div>
      {hasValue(status) && (
        <div>
          <div>Status:</div>
          <div className="font-semibold first-letter:capitalize">{status}</div>
        </div>
      )}
    </div>
  );
};
